/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  shipping-billing-api.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date        : Sep 16, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            : H422335
 * On            : Oct 14, 2020
 * Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 ******************************************************************************/
import API from './api';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import { handleResponse, handleError } from './apiUtils';

class ShippingAndBillingAPI {

    static async getCustomerCBDStatusAPI(soldTo: string): Promise<any> {
        const URL: string = `${CheckoutServiceURL.CUSTOMER_CBD_STATUS_URL}?soldTo=${soldTo}`;
        const data: any = await API.get(URL).then(handleResponse).catch(handleError);
        return data;
    }

    static async getCCPaymetricMetaData(accessToken: string): Promise<any> {
        const URL: string = `${CheckoutServiceURL.GET_CC_PAYMETIRC_META_INFO}/${accessToken}`;
        const data: any = await API.get(URL).then(handleResponse).catch(handleError);
        return data;
    }

}

export default ShippingAndBillingAPI;